"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var prefix = 'useFilter';
var localStorageStore = {
    getFilter: function (namespace) {
        var item = localStorage.getItem(prefix + "/" + namespace + "/filter");
        if (item) {
            return JSON.parse(item);
        }
    },
    saveFilter: function (namespace, filter) {
        localStorage.setItem(prefix + "/" + namespace + "/filter", JSON.stringify(filter));
    },
    getData: function (namespace) {
        var item = localStorage.getItem(prefix + "/" + namespace + "/data");
        if (item) {
            return JSON.parse(item);
        }
    },
    saveData: function (namespace, data) {
        localStorage.setItem(prefix + "/" + namespace + "/data", JSON.stringify(data));
    },
    clear: function () {
        for (var key in localStorage) {
            if (key.startsWith(prefix)) {
                localStorage.removeItem(key);
            }
        }
    },
};
exports.default = localStorageStore;
